// extracted by mini-css-extract-plugin
export default {"regulationContainer":"Statute_regulationContainer__FQBVv","regulationText":"Statute_regulationText__72+3-","sectionNumber":"Statute_sectionNumber__BEsyE"};